import React from 'react';
import { Sheet, SheetContent } from './ui/sheet';
import { Separator } from './ui/separator';

const NavItem = ({ icon, label, active, onClick, testId }) => (
  <button
    data-testid={testId}
    onClick={onClick}
    style={{
      display: 'flex', alignItems: 'center', gap: '10px',
      width: '100%', padding: '10px 14px', borderRadius: '8px',
      border: 'none', cursor: 'pointer', textAlign: 'left',
      fontSize: '14px', fontWeight: active ? 600 : 400,
      background: active ? 'rgba(26,92,46,0.08)' : 'transparent',
      color: active ? '#1a5c2e' : '#555',
      borderLeft: active ? '3px solid #1a5c2e' : '3px solid transparent',
      transition: 'all 0.15s',
      fontFamily: 'IBM Plex Sans, sans-serif',
    }}
    onMouseEnter={e => { if (!active) { e.currentTarget.style.background = 'rgba(26,92,46,0.05)'; e.currentTarget.style.color = '#333'; }}}
    onMouseLeave={e => { if (!active) { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#555'; }}}
  >
    <span style={{ fontSize: '15px', width: '20px', textAlign: 'center', flexShrink: 0 }}>{icon}</span>
    <span>{label}</span>
    {active && <div style={{ marginLeft: 'auto', width: '6px', height: '6px', borderRadius: '50%', background: '#3aaa62', flexShrink: 0 }} />}
  </button>
);

const QuickLink = ({ href, icon, label }) => (
  <a href={href} target="_blank" rel="noopener noreferrer"
    style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '7px 12px', borderRadius: '6px', textDecoration: 'none', color: '#666', fontSize: '13px' }}
    onMouseEnter={e => e.currentTarget.style.background = 'rgba(26,92,46,0.05)'}
    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
  >
    <span style={{ fontSize: '13px', width: '16px', textAlign: 'center' }}>{icon}</span>
    <span>{label}</span>
    <span style={{ marginLeft: 'auto', color: '#ccc', fontSize: '11px' }}>↗</span>
  </a>
);

const SidebarContent = ({ activePage, setActivePage, onClose, onLogout }) => (
  <div className="sidebar-inner" style={{ padding: '0', display: 'flex', flexDirection: 'column', height: '100%', background: '#fff' }}>
    {/* Logo header */}
    <div style={{
      background: 'linear-gradient(150deg, #0d3d1f 0%, #1a5c2e 60%, #2d8a4e 100%)',
      padding: '20px 18px 18px',
      flexShrink: 0,
    }}>
      <img
        src="/valoriza-logo.svg"
        alt="Valoriza"
        style={{ height: '36px', width: 'auto', display: 'block', marginBottom: '10px' }}
      />
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#3aaa62' }} />
        <span style={{ color: 'rgba(255,255,255,0.55)', fontSize: '11px', letterSpacing: '0.5px' }}>Sistema de Alta IT</span>
      </div>
    </div>

    {/* Scrollable content */}
    <div style={{ flex: 1, overflowY: 'auto', padding: '16px 12px', display: 'flex', flexDirection: 'column', gap: '0' }}>

      {/* Navigation */}
      <p style={{ fontSize: '10px', fontWeight: 700, color: '#bbb', textTransform: 'uppercase', letterSpacing: '1.5px', padding: '8px 14px 6px', marginBottom: '4px' }}>Menú</p>
      <nav style={{ display: 'flex', flexDirection: 'column', gap: '2px', marginBottom: '20px' }}>
        <NavItem icon="📋" label="Formulario Alta" active={activePage === 'form'} onClick={() => { setActivePage('form'); onClose?.(); }} testId="sidebar-nav-form" />
        <NavItem icon="📊" label="Panel de Control" active={activePage === 'dashboard'} onClick={() => { setActivePage('dashboard'); onClose?.(); }} testId="sidebar-nav-dashboard" />
        <NavItem icon="📦" label="Formulario Recibí" active={activePage === 'recibi'} onClick={() => { setActivePage('recibi'); onClose?.(); }} testId="sidebar-nav-recibi" />
        <NavItem icon="📁" label="Gestión PDFs" active={activePage === 'admin-pdfs'} onClick={() => { setActivePage('admin-pdfs'); onClose?.(); }} testId="sidebar-nav-admin-pdfs" />
        <NavItem icon="📖" label="Manual MVP" active={activePage === 'manual'} onClick={() => { setActivePage('manual'); onClose?.(); }} testId="sidebar-nav-manual" />
      </nav>

      <Separator style={{ marginBottom: '16px', opacity: 0.5 }} />

      {/* Quick links */}
      <p style={{ fontSize: '10px', fontWeight: 700, color: '#bbb', textTransform: 'uppercase', letterSpacing: '1.5px', padding: '0 14px 6px', marginBottom: '4px' }}>Accesos rápidos</p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1px', marginBottom: '20px' }}>
        <QuickLink href="https://trebol.valorizasm.com/login" icon="🔧" label="Portal TREBOL" />
        <QuickLink href="https://myhub.valorizasm.com" icon="🏢" label="Intranet MyHub" />
        <QuickLink href="https://portal.office.com" icon="📧" label="Office 365" />
      </div>

      <Separator style={{ marginBottom: '16px', opacity: 0.5 }} />

      {/* Workplace Policies */}
      <p style={{ fontSize: '10px', fontWeight: 700, color: '#bbb', textTransform: 'uppercase', letterSpacing: '1.5px', padding: '0 14px 6px', marginBottom: '4px' }}>Políticas Workplace</p>
      <div className="workplace-policies-links" style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '20px' }}>
        <a 
          href="https://customer-assets.emergentagent.com/job_new-hire-welcome/artifacts/3komy3o1_PUESTO_DE_TRABAJO_v02.pdf" 
          target="_blank" 
          rel="noopener noreferrer"
          data-testid="policy-link-medidas"
          className="policy-link"
          style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px', 
            padding: '8px 12px', 
            borderRadius: '6px', 
            textDecoration: 'none', 
            color: '#1a5c2e', 
            fontSize: '13px',
            fontWeight: 500,
            background: 'rgba(26,92,46,0.06)',
            border: '1px solid rgba(26,92,46,0.1)'
          }}
          onMouseEnter={e => e.currentTarget.style.background = 'rgba(26,92,46,0.12)'}
          onMouseLeave={e => e.currentTarget.style.background = 'rgba(26,92,46,0.06)'}
        >
          <span style={{ fontSize: '14px' }}>📋</span>
          <span>Medidas de Protección</span>
          <span style={{ marginLeft: 'auto', color: '#3aaa62', fontSize: '11px' }}>↗</span>
        </a>
        <a 
          href="https://customer-assets.emergentagent.com/job_new-hire-welcome/artifacts/82ryg9wg_pt4900_02_GuiaBuenasPracticas_V3.pdf" 
          target="_blank" 
          rel="noopener noreferrer"
          data-testid="policy-link-buenas-practicas"
          className="policy-link"
          style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px', 
            padding: '8px 12px', 
            borderRadius: '6px', 
            textDecoration: 'none', 
            color: '#1a5c2e', 
            fontSize: '13px',
            fontWeight: 500,
            background: 'rgba(26,92,46,0.06)',
            border: '1px solid rgba(26,92,46,0.1)'
          }}
          onMouseEnter={e => e.currentTarget.style.background = 'rgba(26,92,46,0.12)'}
          onMouseLeave={e => e.currentTarget.style.background = 'rgba(26,92,46,0.06)'}
        >
          <span style={{ fontSize: '14px' }}>📘</span>
          <span>Guía de Buenas Prácticas</span>
          <span style={{ marginLeft: 'auto', color: '#3aaa62', fontSize: '11px' }}>↗</span>
        </a>
      </div>

      <Separator style={{ marginBottom: '16px', opacity: 0.5 }} />

      {/* User info */}
      <div style={{
        background: 'rgba(26,92,46,0.05)', borderRadius: '10px',
        padding: '12px 14px', marginBottom: '12px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
          <div style={{
            width: '32px', height: '32px', borderRadius: '8px',
            background: 'linear-gradient(135deg, #1a5c2e, #3aaa62)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            flexShrink: 0,
          }}>
            <span style={{ color: '#fff', fontSize: '14px' }}>👤</span>
          </div>
          <div style={{ minWidth: 0 }}>
            <p style={{ fontSize: '12px', fontWeight: 600, color: '#1a1a1a', margin: 0, lineHeight: 1.2 }}>CAU Técnico</p>
            <p style={{ fontSize: '10px', color: '#888', margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>altausuarios@valorizasm.com</p>
          </div>
        </div>
        <button
          data-testid="sidebar-logout-button"
          onClick={onLogout}
          style={{
            width: '100%', height: '30px',
            background: 'transparent', border: '1px solid #e0e0e0',
            borderRadius: '6px', cursor: 'pointer',
            fontSize: '12px', color: '#888', fontFamily: 'IBM Plex Sans, sans-serif',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px',
            transition: 'all 0.15s',
          }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = '#f87171'; e.currentTarget.style.color = '#c62828'; e.currentTarget.style.background = '#fdecea'; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = '#e0e0e0'; e.currentTarget.style.color = '#888'; e.currentTarget.style.background = 'transparent'; }}
        >
          <span>↩</span> Cerrar sesión
        </button>
      </div>
    </div>

    {/* Footer */}
    <div style={{ padding: '12px 18px', borderTop: '1px solid hsl(140 18% 90%)', flexShrink: 0 }}>
      <p style={{ fontSize: '10px', color: '#ccc', margin: 0 }}>© 2026 Valoriza IT · v1.0</p>
      <p style={{ fontSize: '10px', color: '#bbb', margin: '3px 0 0', fontStyle: 'italic' }}>Powered by Valoriza's Innovation Team</p>
    </div>
  </div>
);

export default function Sidebar({ activePage, setActivePage, sidebarOpen, setSidebarOpen, onLogout }) {
  return (
    <>
      {/* Desktop Sidebar - always rendered */}
      <div
        id="valoriza-sidebar-desktop"
        className="app-sidebar desktop-only"
        style={{ 
          position: 'fixed', 
          left: 0, 
          top: 0, 
          bottom: 0, 
          width: '260px', 
          zIndex: 1000, 
          display: 'flex', 
          flexDirection: 'column',
          background: '#fff',
          boxShadow: '2px 0 12px rgba(0,0,0,0.08)',
          borderRight: '1px solid rgba(0,0,0,0.06)'
        }}
      >
        <SidebarContent activePage={activePage} setActivePage={setActivePage} onLogout={onLogout} />
      </div>

      {/* Mobile: Sheet */}
      <Sheet open={sidebarOpen} onOpenChange={setSidebarOpen}>
        <SheetContent side="left" style={{ padding: 0, width: '260px' }}>
          <SidebarContent activePage={activePage} setActivePage={setActivePage} onClose={() => setSidebarOpen(false)} onLogout={onLogout} />
        </SheetContent>
      </Sheet>

      <style>{`
        /* Desktop sidebar - always visible on large screens */
        #valoriza-sidebar-desktop {
          display: flex !important;
          flex-direction: column !important;
          visibility: visible !important;
          opacity: 1 !important;
        }
        
        @media (max-width: 768px) {
          #valoriza-sidebar-desktop {
            display: none !important;
          }
        }
        
        .mobile-topbar { display: none; }
        @media (max-width: 768px) {
          .mobile-topbar { display: flex !important; }
        }
      `}</style>
    </>
  );
}
